import * as React from "react";
import api, { $ } from "kw/api";
import { getSubdomain } from "kw/util/utils";

/**
 * Hook to fetch organization feature flags based on subdomain
 *
 * Returns feature flags to control login button visibility
 */
export const useOrganizationFeatureFlags = () => {
  const [flags, setFlags] = React.useState({
    enableAzureLogin: false,
    enableKanopiAuthenticator: false,
  });
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<Error | null>(null);

  React.useEffect(() => {
    const fetchFlags = async () => {
      const subdomain = getSubdomain();

      if (!subdomain) {
        setLoading(false);
        return;
      }

      try {
        const response = await api.query({
          organizationFeatureFlags: {
            enableAzureLogin: true,
            enableKanopiAuthenticator: true,
          },
        });

        setFlags(
          response.organizationFeatureFlags || {
            enableAzureLogin: false,
            enableKanopiAuthenticator: false,
          }
        );
      } catch (err) {
        console.error(err);
        setError(err instanceof Error ? err : new Error(String(err)));
      } finally {
        setLoading(false);
      }
    };

    fetchFlags();
  }, []);

  return { flags, loading, error };
};
